(function () {
    angular.module('app')
        .controller('RelatedCaseStudyController', RelatedCaseStudyController);

    RelatedCaseStudyController.$inject = ['$scope', '$attrs', 'caseStudyResource'];
    function RelatedCaseStudyController($scope, $attrs, caseStudyResource) {
        var ctrl = this;
        ctrl.loading = true;
        ctrl.results = [];
        
        caseStudyResource.list.get({ id: $attrs.source, services: $attrs.services, pageSize: $attrs.page }, function (data) {
            ctrl.results = data;
            ctrl.loading = false;
        })

        /*ctrl.hoverIn = function (event, color) {
            var element = angular.element(event.srcElement || event.target);
            if (!element.hasClass('text')) {
                element = element.parent();
            }

            TweenLite.to(element, 0.5, { backgroundColor: color });

            //element.css({ 'background-color': color });
        }

        ctrl.hoverOut = function (event) {
            var element = angular.element(event.srcElement || event.target);
            if (!element.hasClass('text')) {
                element = element.parent();
            }

            TweenLite.to(element, 0.5, { backgroundColor: 'transparent' });
            //element.css({ 'background-color': 'transparent' });
        }*/
    }
})();